import React        from 'react';
import PropTypes    from 'prop-types';
import Flux         from '../../../flux/Flux';
import ReloadHelper from '../../../utils/ReloadHelper';
import Translations from '../../../utils/Translations';
import UrlBuilder   from '../../../utils/UrlBuilder';

class AlbumDescriptionDetails extends React.Component {
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	/**
	 * @param {Event} e
	 */
	onClick(e) {
		ReloadHelper.reloadWithPjax(e.target.href, e);
	}

	render() {
		const {baseClassName, releaseDate, duration, hasAudio, totalViews} = this.props;
		return (
			<div className={baseClassName}>
				<div className={baseClassName + '-meta'}>
					<span className={baseClassName + '-meta-item'}>{releaseDate}</span>
					<span className={baseClassName + '-meta-item'}>{duration}</span>
					<span className={baseClassName + '-meta-item'}>
						<i className={'icon ' + (hasAudio ? '-icon-speaker-full' : '-icon-speaker-muted-full')} /> {hasAudio ? Translations.get('WithSound') : Translations.get('NoSound')}
					</span>
					<span className={baseClassName + '-meta-item'}><i className="icon -icon-eyes-full" /> {totalViews}</span>
				</div>
			</div>
		);
	}
}

AlbumDescriptionDetails.propTypes = {
	baseClassName:     PropTypes.string,
	totalViews:        PropTypes.number,
	hasAudio:          PropTypes.bool,
	duration:          PropTypes.string,
	releaseDate:       PropTypes.string,
};

AlbumDescriptionDetails.defaultProps = {
	baseClassName:     '',
};

export default AlbumDescriptionDetails;
